import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api } from '../lib/api';

const EventContext = createContext(null);

export function EventProvider({ children }) {
  const [config, setConfig] = useState(null);
  const [status, setStatus] = useState('loading'); // loading | ready | error

  const load = useCallback(async () => {
    setStatus('loading');
    try {
      const cfg = await api.getConfig();
      setConfig(cfg);
      setStatus('ready');
    } catch (e) {
      setStatus('error');
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <EventContext.Provider value={{ config, status, reload: load }}>
      {children}
    </EventContext.Provider>
  );
}

export const useEvent = () => useContext(EventContext);
